import SectorSection from "./SectorSection";

export default function SectionPage() {
    const sectorsData = [
        {
            title: "Construction & Engineering",
            badge: "HEAVY INDUSTRY & INFRASTRUCTURE",
            subtitle: "Engineers, Masons & Skilled Riggers",
            description: "We supply experienced construction teams tested under strict safety standards for mega infrastructure, high-rise, and commercial development projects.",
            imageSrc: "28.png",
            reverse: false, // ইমেজ ডানে থাকবে
            features: [
                { icon: "fa fa-hard-hat", text: "Civil, Electrical & Mechanical Engineers" },
                { icon: "fa fa-tools", text: "Masons, Carpenters & Steel Fixers" },
                { icon: "fa fa-wrench", text: "Certified Welders, Electricians & Plumbers" },
                { icon: "fa fa-shield-alt", text: "Trained in international HSE site safety protocols" }
            ]
        },
        {
            title: "Factory & Manufacturing",
            badge: "INDUSTRIAL SECTOR",
            subtitle: "Production & Assembly Experts",
            description: "Our workforce powers major production and manufacturing hubs across Eastern Europe and the Middle East with precision and efficiency.",
            imageSrc: "35.jpg",
            reverse: true, // চাইলে ইমেজ বামে বা ডানে করার জন্য এটা ব্যবহার করতে পারেন
            features: [
                { icon: "fa fa-cogs", text: "CNC & Machine Operators" },
                { icon: "fa fa-boxes", text: "Assembly Line & Packaging Workers" },
                { icon: "fa fa-warehouse", text: "Warehouse Packers, Loaders & Sorters" }
            ]
        },
        {
            title: "Hospitality & Service Sector",
            badge: "SERVICE & CUSTOMER CARE",
            subtitle: "Hotel, Restaurant & Front Desk Staff",
            description: "Delivering courteous, multilingual, and customer-oriented hospitality personnel tailored for luxury hotels, resorts, and dining establishments.",
            imageSrc: "41.png",
            reverse: false,
            features: [
                { icon: "fa fa-concierge-bell", text: "Front Desk, Housekeeping & Concierge" },
                { icon: "fa fa-utensils", text: "Chefs, Kitchen Helpers, & Food Servers" },
                { icon: "fa fa-broom", text: "Facility Maintenance & Janitorial Teams" }
            ]
        }
    ];

    return (
        <main className="main">
            {sectorsData.map((sector, index) => (
                <SectorSection
                    key={index}
                    title={sector.title}
                    badge={sector.badge}
                    subtitle={sector.subtitle}
                    description={sector.description}
                    features={sector.features}
                    imageSrc={sector.imageSrc}
                    reverse={sector.reverse}
                />
            ))}
        </main>
    );
}